<template>
    <tr v-on:dblclick="$hasPermission('requests.show') && toEditRequest()" :class="{'text-danger-extra-muted': !!request.parent_id, 'border-indicate': visit_today}">
        <td class="cell-select">
            <div v-if="allowSelect" class="custom-control custom-checkbox">
                <input v-model="selected" type="checkbox" class="custom-control-input" :id="'select_' + request.id" :disabled="!!request.parent_id">
                <label class="custom-control-label" :for="'select_' + request.id"></label>
            </div>
        </td>
        <td>
            <template v-if="!request.parent_id">
                <router-link v-if="$hasPermission('requests.show')" :to="{ name: 'request', params: {id: request.id} }" class="">{{request.id}}</router-link>
                <span v-else>{{request.id}}</span>
            </template>
            <template v-if="request.parent_id">
                <router-link v-if="$hasPermission('requests.show')" :to="{ name: 'request', params: {id: request.parent_id} }" class="text-danger">{{request.parent_id}}</router-link>
                <span class="text-danger" v-else>{{request.parent_id}}</span>
            </template>
            <span v-if="request.is_spam" class="badge badge-danger ml-1">СПАМ</span>
        </td>
        <template v-for="c in columns">
            <td v-if="c === 'full_name'">{{full_name}}</td>
            <td v-if="c === 'phone'">{{request.phone ? phoneView(request.phone) : ''}}</td>
            <td v-if="c === 'phone2'">{{request.phone2 ? phoneView(request.phone2) : ''}}</td>
            <td v-if="c === 'phone3'">{{request.phone3 ? phoneView(request.phone3) : ''}}</td>
            <td v-if="c === 'phone4'">{{request.phone4 ? phoneView(request.phone4) : ''}}</td>
            <td v-if="c === 'phone5'">{{request.phone5 ? phoneView(request.phone5) : ''}}</td>
            <td v-if="c === 'phone6'">{{request.phone6 ? phoneView(request.phone6) : ''}}</td>
            <td v-if="c === 'phone_region'" class="small">{{request.phone_region ? request.phone_region.name : ''}}</td>
            <td v-if="c === 'ip'" class="small">{{request.ip}}</td>
            <td v-if="c === 'ip_region'" class="small">{{ip_region}}</td>
            <td v-if="c === 'registration_region'" class="small">{{registration_region}}</td>
            <td v-if="c === 'residence_region'" class="small">{{residence_region}}</td>
            <td v-if="c === 'discount'">{{request.discount}}</td>
            <td v-if="c === 'primary_car_brand_name'">{{request.primary_car_brand_name}}</td>
            <td v-if="c === 'primary_car_model_name'">{{request.primary_car_model_name}}</td>
            <td v-if="c === 'primary_car_modification_name'">{{request.primary_car_modification_name}}</td>
            <td v-if="c === 'primary_car_complete_name'">{{request.primary_car_complete_name}}</td>
            <td v-if="c === 'primary_car_cost'">{{request.primary_car_cost}}</td>
            <td v-if="c === 'primary_car_color'">{{request.primary_car_color}}</td>
            <td v-if="c === 'primary_car_year'">{{request.primary_car_year}}</td>
            <td v-if="c === 'primary_car_condition'">{{primary_car_condition}}</td>
            <td v-if="c === 'primary_car_link'"><a class="small" v-if="request.primary_car_link" :href="request.primary_car_link" target="_blank">открыть</a></td>
            <td v-if="c === 'car_brand_name'">{{request.car_brand_name}}</td>
            <td v-if="c === 'car_model_name'">{{request.car_model_name}}</td>
            <td v-if="c === 'car_modification_name'">{{request.car_modification_name}}</td>
            <td v-if="c === 'car_complete_name'">{{request.car_complete_name}}</td>
            <td v-if="c === 'car_cost'">{{request.car_cost}}</td>
            <td v-if="c === 'car_color'">{{request.car_color}}</td>
            <td v-if="c === 'car_year'">{{request.car_year}}</td>
            <td v-if="c === 'car_condition'">{{car_condition}}</td>
            <td v-if="c === 'yclid'" class="small">{{request.yclid}}</td>
            <td v-if="c === 'utm_source'" class="small">{{request.utm_source}}</td>
            <td v-if="c === 'utm_medium'" class="small">{{request.utm_medium}}</td>
            <td v-if="c === 'utm_campaign'" class="small">{{request.utm_campaign}}</td>
            <td v-if="c === 'utm_term'" class="small">{{request.utm_term}}</td>
            <td v-if="c === 'utm_content'" class="small">{{request.utm_content}}</td>
            <td v-if="c === 'referer'" class="small">{{request.referer}}</td>
            <td :class="{'cell-sort': activeColumns.includes('call_date')}" v-if="c === 'call_date'"><CellDateTime :size="'small'" :time_size="'large'" v-if="request.call_date" :datetime="request.call_date" :time_format="'HH:mm'" /></td>
            <td :class="{'cell-sort': activeColumns.includes('visit_date')}" v-if="c === 'visit_date'"><CellDateTime :size="'small'" :time_size="'large'" v-if="request.visit_date" :datetime="request.visit_date" :time_format="'HH:mm'" /></td>
            <td :class="{'cell-sort': activeColumns.includes('visited_at')}" v-if="c === 'visited_at'"><CellDateTime :size="'small'" :time_size="'large'" v-if="request.visited_at" :datetime="request.visited_at" :time_format="'HH:mm'" /></td>
            <td :class="{'cell-sort': activeColumns.includes('purchased_at')}" v-if="c === 'purchased_at'"><CellDateTime :size="'small'" :time_size="'large'" v-if="request.purchased_at" :datetime="request.purchased_at" :time_format="'HH:mm'" /></td>
            <td v-if="c === 'type'">{{type}}</td>
            <td v-if="c === 'credit_initial_payment'">{{request.credit_initial_payment}}</td>
            <td v-if="c === 'credit_term'">{{request.credit_term}}</td>
            <td v-if="c === 'status'"><RequestStatusBadge v-if="!request.parent_id" :slug="request.status" :with-additional="true" :slug_additional="request.status_additional" /></td>
            <td v-if="c === 'in_credit_department'">{{request.in_credit_department ? "Да" : "Нет"}}</td>
            <td :class="{'cell-sort': activeColumns.includes('in_credit_department_datetime')}" v-if="c === 'in_credit_department_datetime'"><CellDateTime :size="'small'" :time_size="'large'" v-if="request.in_credit_department_datetime" :datetime="request.in_credit_department_datetime" :time_format="'HH:mm'" /></td>
            <td :class="{'cell-sort': activeColumns.includes('visited_credit_department_at')}" v-if="c === 'visited_credit_department_at'"><CellDateTime :size="'small'" :time_size="'large'" v-if="request.visited_credit_department_at" :datetime="request.visited_credit_department_at" :time_format="'HH:mm'" /></td>
            <td v-if="c === 'credit_status'"><RequestCreditStatusBadge v-if="request.credit_status" :slug="request.credit_status" /></td>
            <td v-if="c === 'bank_decision'"><RequestBankDecisionBadge v-if="request.bank_decision" :slug="request.bank_decision" /></td>
            <td v-if="c === 'is_trade_in'">{{request.is_trade_in ? "Да" : "Нет"}}</td>
            <td v-if="c === 'is_utilisation'">{{request.is_utilisation ? "Да" : "Нет"}}</td>
            <td v-if="c === 'source'" class="small text-nowrap">{{request.source ? request.source.name : ''}}</td>
            <td v-if="c === 'operator_name'" class="small">{{operator}}</td>
            <td v-if="c === 'sales_manager_name'" class="small">{{request.sales_manager ? request.sales_manager.name : ''}}</td>
            <td v-if="c === 'credit_manager_name'" class="small">{{request.credit_manager ? request.credit_manager.name : ''}}</td>
            <td :class="{'cell-sort': activeColumns.includes('created_at')}" v-if="c === 'created_at'"><CellDateTime :size="'small'" :time_size="'small'" :datetime="request.created_at" :time_format="'HH:mm'" /></td>
            <td v-if="c === 'credit_score'"><CreditScoreIcon :score="request.credit_score"/></td>
        </template>
        <td width="20"><PlatformIcon :id="request.platform_id" /></td>
    </tr>
</template>

<script>
    import RequestStatusBadge from "./RequestStatusBadge";
    import CellDateTime from "../others/table/CellDateTime";
    import PlatformHelper from "../../helpers/platform";
    import PlatformIcon from "../platforms/PlatformIcon";
    import RequestCreditStatusBadge from "./RequestCreditStatusBadge";
    import CreditScoreIcon from "./CreditScoreIcon";
    import RequestBankDecisionBadge from "./RequestBankDecisionBadge";
    export default {
        components: {
            RequestBankDecisionBadge,
            CreditScoreIcon, RequestCreditStatusBadge, PlatformIcon, RequestStatusBadge, CellDateTime},
        props: {
            request: {
                type: Object,
            },
            activeColumns: {
                type: Array,
                required: false,
                default: [],
            }
        },
        name: "RequestTableItem",
        mounted() {
            let self = this;
            // if (this.allowSelect) {
            //     this.$bus.$on('request:select', id => {
            //         if (id === self.request.id) self.select();
            //     });
            //     this.$bus.$on('request:unselect', id => {
            //         if (id === self.request.id) self.unselect();
            //     });
            // }
        },
        beforeDestroy() {
            this.$store.dispatch('requests/selectedPull', this.request.id);
            // this.$bus.$off(['request:select', 'request:unselect']);
        },
        computed: {
            allowSelect() {
                return !this.request.parent_id;
            },
            columns() {
                return this.$store.getters['columns/requests'];
            },
            full_name: function () {
                return [this.request.last_name,this.request.first_name,this.request.middle_name].join(' ').trim();
            },
            car_condition: function () {
                switch (this.request.car_condition) {
                    case 'new':
                        return 'Новый';
                    case 'used':
                        return 'Подержанный';
                    default:
                        return '';
                }
            },
            primary_car_condition: function () {
                switch (this.request.primary_car_condition) {
                    case 'new':
                        return 'Новый';
                    case 'used':
                        return 'Подержанный';
                    default:
                        return '';
                }
            },
            type: function () {
                switch (this.request.type) {
                    case 'credit':
                        return 'Кредит';
                    case 'cash':
                        return 'Наличные';
                    default:
                        return '';
                }
            },
            residence_region: function () {
                if (this.request.residence_region) return this.request.residence_region.name;
                return null;
            },
            registration_region: function () {
                if (this.request.registration_region) return this.request.registration_region.name;
                return null;
            },
            ip_region: function () {
                if (this.request.ip_region) return this.request.ip_region.name;
                return null;
            },
            operator: function () {
                if (this.request.operator) return this.request.operator.name;
                return null;
            },
            source: function () {
                if (this.request.source) return this.request.source.name;
                return null;
            },
            visit_today: function () {
                return moment().format('YYYY-MM-DD') === moment(this.request.visit_date).format('YYYY-MM-DD');
            },
            // columns() {
            //     return ;
            // }
            selected: {
                get () {
                    return this.$store.getters['requests/selected'].indexOf(this.request.id) !== -1;
                },
                set (value) {
                    value ? this.select() : this.unselect();
                }
            },
        },
        methods: {
            toEditRequest: function () {
                let id = this.request.parent_id ? this.request.parent_id : this.request.id;
                this.$router.push({name: 'request', params: {id: id}});
            },
            select() {
                this.$store.dispatch('requests/selectedPush', this.request.id);
            },
            unselect() {
                this.$store.dispatch('requests/selectedPull', this.request.id);
            },
            phoneView(phone) {
                return this.$hasPermission('request.phone.show_full.without_challenge') ? phone : this.$hidePartPhone(phone);
            },
        }
    }
</script>

